module.exports = __webpack_public_path__ + "img/pr-6.3c5089d4.png";